import { SET_ORIGINAL_ITEM } from '../../../redux-types/boundingBox';
import type { IStore } from '../../../utils/offerHandler/types/IStore';

import { registerPrehook } from '../../../lib/reduxStateHooks';

registerPrehook(SET_ORIGINAL_ITEM, (store: IStore, action: any) => {
  if (action?.data) {
    action.data.description = '';
  }
});
